var React = require('react');

function CarretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.3848 2.19239L12.1924 12.3848L1.99999 2.19239","stroke":"white","strokeWidth":"4"}));
}

CarretInline.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = CarretInline;

CarretInline.default = CarretInline;
